import {PermissionRowAbstract} from "./AbstractRow";
import immutableHtml from './immutable.html?raw';

export let template = immutableHtml;

export class viewModel extends PermissionRowAbstract {
}
